document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initHeroParallax();
  initMarquees();
  initProductGallery();
  initVariantPicker();
  initFaq();
});

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (prefersReducedMotion()) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { io.observe(el); });
}

function initHeroParallax() {
  var scene = document.querySelector('[data-mt-parallax]');
  if (!scene) return;
  if (prefersReducedMotion() || window.matchMedia('(pointer: coarse)').matches) return;
  var target = scene.querySelector('[data-mt-parallax-target]');
  if (!target) return;
  scene.addEventListener('mousemove', function (e) {
    var rect = scene.getBoundingClientRect();
    var x = (e.clientX - rect.left) / rect.width - 0.5;
    var y = (e.clientY - rect.top) / rect.height - 0.5;
    target.style.transform = 'translate(' + (x * -18) + 'px,' + (y * -14) + 'px)';
  });
  scene.addEventListener('mouseleave', function () {
    target.style.transform = 'translate(0,0)';
  });
}

function initMarquees() {
  document.querySelectorAll('[data-mt-marquee]').forEach(function (wrap) {
    var track = wrap.querySelector('.mt-marquee-track');
    if (!track || track.dataset.mtDup) return;
    track.innerHTML += track.innerHTML;
    track.dataset.mtDup = '1';
  });
}

function initProductGallery() {
  var gallery = document.querySelector('[data-mt-gallery]');
  if (!gallery) return;
  var main = gallery.querySelector('[data-mt-gallery-main]');
  var thumbs = gallery.querySelectorAll('[data-mt-gallery-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      var alt = thumb.getAttribute('data-alt') || '';
      if (!full) return;
      main.style.opacity = '0';
      window.setTimeout(function () {
        main.src = full;
        main.alt = alt;
        main.style.opacity = '1';
      }, 160);
      thumbs.forEach(function (t) { t.classList.remove('mt-thumb-active'); });
      thumb.classList.add('mt-thumb-active');
    });
  });
}

function initVariantPicker() {
  var form = document.querySelector('[data-mt-product-form]');
  if (!form) return;
  var variantsJson = form.querySelector('[data-mt-variants-json]');
  if (!variantsJson) return;
  var variants;
  try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }

  var selects = form.querySelectorAll('[data-mt-option-select]');
  var idInput = form.querySelector('[data-mt-variant-id]');
  var priceEl = form.querySelector('[data-mt-price]');
  var compareEl = form.querySelector('[data-mt-compare-price]');
  var submitBtn = form.querySelector('[data-mt-submit]');
  var submitLabel = submitBtn ? submitBtn.querySelector('[data-mt-submit-label]') : null;

  function money(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    });
  }

  function findVariant() {
    var selected = Array.prototype.map.call(selects, function (s) { return s.value; });
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
  }

  function update() {
    var variant = findVariant();
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    if (priceEl && variant.price != null) priceEl.textContent = money(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = money(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      if (submitLabel) submitLabel.textContent = variant.available ? submitBtn.getAttribute('data-label-add') : submitBtn.getAttribute('data-label-sold-out');
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', update); });
  update();
}

function initFaq() {
  document.querySelectorAll('[data-mt-faq-item]').forEach(function (item) {
    var trigger = item.querySelector('[data-mt-faq-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('mt-faq-open');
      item.closest('[data-mt-faq]').querySelectorAll('[data-mt-faq-item]').forEach(function (i) {
        i.classList.remove('mt-faq-open');
      });
      if (!isOpen) item.classList.add('mt-faq-open');
    });
  });
}
